import React, {Component } from 'react';

import closeIcon from '../../../../icons/close.svg';
import Backdrop from '../../Backdrop/Backdrop';
import Aux from '../../../../containers/hoc/Auxiliary';

import classes from './StartingModal.css';

class Modal extends Component {
    shouldComponentUpdate(nextProps, nextState){
        return nextProps.show !== this.props.show
        || nextProps.children !== this.props.children;
    }


    render(){
        return(

            
            <Aux>

                
                <Backdrop show={this.props.show} clicked={this.props.modalClosed} />
                <div   
                    className={classes.Modal} 
                    style={{
                        transform: this.props.show ? 'translateY(0)' : 'translateY(-100vh)',
                        opacity: this.props.show ? '1' : '0'
                    }}>
                    <div className={classes.CloseButton} >
                        <img 
                            onClick={this.props.modalClosed}
                            src={closeIcon}
                            alt="not found" />
                    </div>
                    {this.props.children}
                </div>
            </Aux>
        )
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/UI/Modal/StartingModal/StartingModal.js